import moment from 'moment';

export const DateFormat = 'YYYY-MM-DD';

const defaultTimePeriod = [
  moment()
    .subtract(1, 'w')
    .format(DateFormat),
  moment().format(DateFormat),
];

export interface DashboardSettings {
  currentRenderQrCode: 'business' | 'popsup' | 'pure';
  lineChartType: 'subtotal' | 'qrcode';
  filters: {
    periodType: 'week' | 'month' | 'year' | 'custom';
    customPeriod: string[] | false;
    // timePeriod: {
    //   key: 'week' | 'month' | 'year' | 'custom';
    //   value?: any;
    // };
  };

  data: any;
}

export default {
  filters: {
    periodType: 'week',
    customPeriod: defaultTimePeriod,
  },
  lineChartType: 'subtotal',
} as DashboardSettings;

export const spaceName = 'odDashboard';
